// // import React, { useState, useEffect } from "react";
// // import { motion, AnimatePresence } from "framer-motion";
// // import { FiUser, FiShoppingBag, FiSearch, FiMenu, FiX } from "react-icons/fi";

// // const NavBar = ({ navigate, cartCount, wishlistCount, user }) => {
// //   const [mobileOpen, setMobileOpen] = useState(false);
// //   const [searchOpen, setSearchOpen] = useState(false);
// //   const [isAtTop, setIsAtTop] = useState(true);

// //   useEffect(() => {
// //     document.body.style.overflow = mobileOpen ? "hidden" : "";
// //     return () => {
// //       document.body.style.overflow = "";
// //     };
// //   }, [mobileOpen]);

// //   useEffect(() => {
// //     const handleScroll = () => {
// //       setIsAtTop(window.scrollY <= 0);
// //     };
// //     window.addEventListener("scroll", handleScroll, { passive: true });
// //     handleScroll();
// //     return () => window.removeEventListener("scroll", handleScroll);
// //   }, []);

// //   const links = [
// //     { label: "HOME", page: "home" },
// //     { label: "SHOP ALL", page: "products" },
// //     { label: "ABOUT US", page: "home" },
// //     { label: "CONTACT", page: "home" },
// //   ];

// //   const IconBtn = ({ onClick, label, badge, children }) => (
// //     <button
// //       onClick={onClick}
// //       aria-label={label}
// //       style={{
// //         position: "relative",
// //         background: "none",
// //         border: "none",
// //         cursor: "pointer",
// //         color: "#fff",
// //         padding: "6px 8px",
// //         display: "flex",
// //         alignItems: "center",
// //       }}
// //     >
// //       {children}
// //       {badge > 0 && (
// //         <span
// //           style={{
// //             position: "absolute",
// //             top: 2,
// //             right: 2,
// //             background: "#e8003d",
// //             color: "#fff",
// //             borderRadius: "50%",
// //             width: 15,
// //             height: 15,
// //             display: "flex",
// //             alignItems: "center",
// //             justifyContent: "center",
// //             fontSize: 8,
// //             fontWeight: 700,
// //           }}
// //         >
// //           {badge}
// //         </span>
// //       )}
// //     </button>
// //   );

// //   return (
// //     <>
// //       {/* ── ANNOUNCEMENT BAR ── */}
// //       <div
// //         style={{
// //           background: "#fff",
// //           color: "#000",
// //           textAlign: "center",
// //           padding: "8px 16px",
// //           fontSize: "clamp(11px,1.3vw,13px)",
// //           fontFamily: "'Barlow Condensed', 'DM Sans', sans-serif",
// //           fontWeight: 600,
// //           letterSpacing: "0.06em",
// //           position: "fixed",
// //           top: 0,
// //           left: 0,
// //           right: 0,
// //           zIndex: 101,
// //         }}
// //       >
// //         GET 10% OFF ON PREPAID ORDERS
// //       </div>

// //       {/* ── MAIN NAV WRAPPER ── */}
// //       <nav
// //         style={{
// //           position: "fixed",
// //           top: 32,
// //           left: 0,
// //           right: 0,
// //           zIndex: 100,
// //           width: "100%",
// //           display: "flex",
// //           justifyContent: "center",
// //           padding: isAtTop ? 0 : "10px 0",
// //           transition: "padding 0.3s ease",
// //         }}
// //         aria-label="Main navigation"
// //       >
// //         <div
// //           style={{
// //             width: isAtTop ? "100%" : "96%",
// //             maxWidth: isAtTop ? "none" : 1400,
// //             height: 56,
// //             borderRadius: isAtTop ? 0 : 999,
// //             background: isAtTop ? "#000" : "rgba(126, 126, 126, 0.6)",
// //             backdropFilter: isAtTop ? "none" : "blur(8px)",
// //             WebkitBackdropFilter: isAtTop ? "none" : "blur(14px)",
// //             border: isAtTop
// //               ? "none"
// //               : "1px solid rgba(255,255,255,0.08)",
// //             borderBottom:
// //               isAtTop
// //                 ? "1px solid rgba(255,255,255,0.08)"
// //                 : "1px solid rgba(255,255,255,0.08)",
// //             boxShadow: isAtTop
// //               ? "none"
// //               : "0 8px 30px rgba(0,0,0,0.45), 0 1.5px 5px rgba(0,0,0,0.25)",
// //             transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)",
// //             display: "flex",
// //             alignItems: "center",
// //             position: "relative"
// //           }}
// //         >
// //           <div
// //             style={{
// //               width: "100%",
// //               height: "100%",
// //               display: "flex",
// //               alignItems: "center",
// //               justifyContent: "space-between",
// //               padding: "0 clamp(16px,3vw,32px)",
// //             }}
// //           >
// //             {/* LEFT: Nav Links & Hamburger */}
// //             <div
// //               style={{
// //                 flex: 1,
// //                 display: "flex",
// //                 alignItems: "center",
// //                 gap: 8,
// //               }}
// //             >
// //               {/* Hamburger — mobile only */}
// //               <button
// //                 onClick={() => setMobileOpen(true)}
// //                 aria-label="Open menu"
// //                 className="ll-hamburger"
// //                 style={{
// //                   display: "none",
// //                   background: "none",
// //                   border: "none",
// //                   cursor: "pointer",
// //                   color: "#fff",
// //                   padding: 6,
// //                 }}
// //               >
// //                 <FiMenu size={22} />
// //               </button>

// //               {/* Desktop Nav Links */}
// //               <div
// //                 className="ll-desktop-links"
// //                 style={{
// //                   display: "flex",
// //                   gap: "clamp(16px,2.5vw,36px)",
// //                   alignItems: "center",
// //                 }}
// //               >
// //                 {links.map((l) => (
// //                   <button
// //                     key={l.label}
// //                     onClick={() => navigate(l.page)}
// //                     style={{
// //                       background: "none",
// //                       border: "none",
// //                       cursor: "pointer",
// //                       color: "#fff",
// //                       fontFamily:
// //                         "'Barlow Condensed', 'DM Sans', sans-serif",
// //                       fontSize: "clamp(12px,1.1vw,14px)",
// //                       fontWeight: 600,
// //                       letterSpacing: "0.1em",
// //                       padding: 0,
// //                       transition: "color 0.2s",
// //                     }}
// //                     onMouseEnter={(e) =>
// //                       (e.target.style.color = "#e8003d")
// //                     }
// //                     onMouseLeave={(e) =>
// //                       (e.target.style.color = "#fff")
// //                     }
// //                   >
// //                     {l.label}
// //                   </button>
// //                 ))}
// //               </div>
// //             </div>

// //             {/* CENTER: Brand Logo */}
// //             <div
// //               style={{
// //                 flex: "0 1 auto",
// //                 display: "flex",
// //                 alignItems: "center",
// //                 justifyContent: "center",
// //                 width: "100%",
// //                 position: "absolute",
// //                 left: 0,
// //                 right: 0,
// //                 pointerEvents: "none", // ensures only logo is clickable, not the space
// //                 zIndex: 2,
// //                 height: "100%",
// //               }}
// //             >
// //               <span
// //                 className="ll-desktop-logo"
// //                 onClick={() => navigate("home")}
// //                 style={{
// //                   fontFamily:
// //                     "'Playfair Display', 'Cormorant Garamond', 'Barlow Condensed', 'Impact', serif",
// //                   fontWeight: 900,
// //                   fontSize: "clamp(18px,2.0vw,26px)",
// //                   color: "#fff",
// //                   letterSpacing: "0.11em",
// //                   cursor: "pointer",
// //                   userSelect: "none",
// //                   lineHeight: 1.08,
// //                   textShadow: "0 2px 10px rgba(0,0,0,0.26)",
// //                   textTransform: "uppercase",
// //                   pointerEvents: "auto", // make the logo itself clickable
// //                 }}
// //               >
// //                 UNLEASH CLUB
// //               </span>
// //             </div>

// //             {/* RIGHT: Icons */}
// //             <div
// //               style={{
// //                 flex: 1,
// //                 display: "flex",
// //                 alignItems: "center",
// //                 justifyContent: "flex-end",
// //                 gap: 0,
// //               }}
// //             >
// //               <IconBtn
// //                 onClick={() => setSearchOpen((v) => !v)}
// //                 label="Search"
// //               >
// //                 <FiSearch size={18} />
// //               </IconBtn>
// //               <IconBtn
// //                 onClick={() => navigate(user ? "profile" : "auth")}
// //                 label="Account"
// //               >
// //                 <FiUser size={18} />
// //               </IconBtn>
// //               <IconBtn
// //                 onClick={() => navigate("cart")}
// //                 label="Cart"
// //                 badge={cartCount}
// //               >
// //                 <FiShoppingBag size={18} />
// //               </IconBtn>
// //             </div>
// //           </div>

// //           {/* Search Bar dropdown */}
// //           <AnimatePresence>
// //             {searchOpen && (
// //               <motion.div
// //                 initial={{ opacity: 0, y: -8 }}
// //                 animate={{ opacity: 1, y: 0 }}
// //                 exit={{ opacity: 0, y: -8 }}
// //                 style={{
// //                   position: "absolute",
// //                   top: "100%",
// //                   left: 0,
// //                   right: 0,
// //                   marginTop: isAtTop ? 0 : 10,
// //                   background: "rgba(17,17,17,0.85)",
// //                   backdropFilter: "blur(14px)",
// //                   WebkitBackdropFilter: "blur(14px)",
// //                   borderRadius: isAtTop ? 0 : 16,
// //                   border: "1px solid rgba(255,255,255,0.1)",
// //                   padding: "12px clamp(16px,3vw,32px)",
// //                 }}
// //               >
// //                 <div
// //                   style={{
// //                     maxWidth: 600,
// //                     margin: "0 auto",
// //                     display: "flex",
// //                     gap: 0,
// //                   }}
// //                 >
// //                   <input
// //                     autoFocus
// //                     placeholder="Search products..."
// //                     style={{
// //                       flex: 1,
// //                       background: "rgba(255,255,255,0.07)",
// //                       border: "1px solid rgba(255,255,255,0.15)",
// //                       borderRight: "none",
// //                       color: "#fff",
// //                       padding: "10px 14px",
// //                       fontSize: 14,
// //                       fontFamily: "'DM Sans', sans-serif",
// //                       borderRadius: "2px 0 0 2px",
// //                       outline: "none",
// //                     }}
// //                   />
// //                   <button
// //                     style={{
// //                       background: "#e8003d",
// //                       border: "none",
// //                       color: "#fff",
// //                       padding: "10px 18px",
// //                       cursor: "pointer",
// //                       borderRadius: "0 2px 2px 0",
// //                       fontFamily: "'Barlow Condensed', sans-serif",
// //                       fontWeight: 700,
// //                       letterSpacing: "0.1em",
// //                       fontSize: 13,
// //                     }}
// //                   >
// //                     SEARCH
// //                   </button>
// //                 </div>
// //               </motion.div>
// //             )}
// //           </AnimatePresence>
// //         </div>
// //       </nav>

// //       {/* ── MOBILE DRAWER ── */}
// //       <AnimatePresence>
// //         {mobileOpen && (
// //           <>
// //             <motion.div
// //               key="backdrop"
// //               initial={{ opacity: 0 }}
// //               animate={{ opacity: 0.6 }}
// //               exit={{ opacity: 0 }}
// //               onClick={() => setMobileOpen(false)}
// //               style={{
// //                 position: "fixed",
// //                 inset: 0,
// //                 background: "#000",
// //                 zIndex: 200,
// //               }}
// //             />
// //             <motion.div
// //               key="drawer"
// //               initial={{ x: "-100%" }}
// //               animate={{ x: 0 }}
// //               exit={{ x: "-100%" }}
// //               transition={{ type: "spring", stiffness: 280, damping: 28 }}
// //               style={{
// //                 position: "fixed",
// //                 top: 0,
// //                 left: 0,
// //                 bottom: 0,
// //                 width: "min(300px, 85vw)",
// //                 background: "rgba(10,10,10,0.85)",
// //                 backdropFilter: "blur(16px)",
// //                 WebkitBackdropFilter: "blur(16px)",
// //                 zIndex: 201,
// //                 display: "flex",
// //                 flexDirection: "column",
// //                 padding: "24px 28px",
// //                 borderRight: "1px solid rgba(255,255,255,0.08)",
// //               }}
// //             >
// //               <div
// //                 style={{
// //                   display: "flex",
// //                   justifyContent: "space-between",
// //                   alignItems: "center",
// //                   marginBottom: 36,
// //                 }}
// //               >
// //                 <span
// //                   style={{
// //                     fontFamily: "'Barlow Condensed', 'Impact', sans-serif",
// //                     fontWeight: 800,
// //                     fontSize: 20,
// //                     color: "#fff",
// //                     letterSpacing: "0.08em",
// //                   }}
// //                 >
// //                   UNLEASH CLUB
// //                 </span>
// //                 <button
// //                   onClick={() => setMobileOpen(false)}
// //                   style={{
// //                     background: "none",
// //                     border: "none",
// //                     cursor: "pointer",
// //                     color: "#fff",
// //                     padding: 4,
// //                   }}
// //                 >
// //                   <FiX size={22} />
// //                 </button>
// //               </div>

// //               <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
// //                 {links.map((l) => (
// //                   <button
// //                     key={l.label}
// //                     onClick={() => {
// //                       setMobileOpen(false);
// //                       navigate(l.page);
// //                     }}
// //                     style={{
// //                       background: "none",
// //                       border: "none",
// //                       cursor: "pointer",
// //                       color: "#fff",
// //                       fontFamily:
// //                         "'Barlow Condensed', 'DM Sans', sans-serif",
// //                       fontSize: 20,
// //                       fontWeight: 600,
// //                       letterSpacing: "0.1em",
// //                       textAlign: "left",
// //                       padding: "14px 0",
// //                       borderBottom: "1px solid rgba(255,255,255,0.07)",
// //                       transition: "color 0.2s",
// //                     }}
// //                     onMouseEnter={(e) =>
// //                       (e.currentTarget.style.color = "#e8003d")
// //                     }
// //                     onMouseLeave={(e) =>
// //                       (e.currentTarget.style.color = "#fff")
// //                     }
// //                   >
// //                     {l.label}
// //                   </button>
// //                 ))}
// //               </div>

// //               <div
// //                 style={{
// //                   marginTop: "auto",
// //                   paddingTop: 24,
// //                   borderTop: "1px solid rgba(255,255,255,0.08)",
// //                   display: "flex",
// //                   gap: 12,
// //                 }}
// //               >
// //                 <IconBtn
// //                   onClick={() => {
// //                     setMobileOpen(false);
// //                     navigate("cart");
// //                   }}
// //                   label="Cart"
// //                   badge={cartCount}
// //                 >
// //                   <FiShoppingBag size={22} />
// //                 </IconBtn>
// //                 <IconBtn
// //                   onClick={() => {
// //                     setMobileOpen(false);
// //                     navigate(user ? "profile" : "auth");
// //                   }}
// //                   label="Account"
// //                 >
// //                   <FiUser size={22} />
// //                 </IconBtn>
// //               </div>
// //             </motion.div>
// //           </>
// //         )}
// //       </AnimatePresence>

// //       <style>{`
// //         @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800&display=swap');
// //         @media (max-width: 768px) {
// //           .ll-hamburger { display: flex !important; }
// //           .ll-desktop-links { display: none !important; }
// //           .ll-desktop-logo { display: flex !important; }
// //         }
// //         @media (min-width: 769px) {
// //           .ll-hamburger { display: none !important; }
// //           .ll-desktop-logo { display: flex !important; }
// //         }
// //       `}</style>
// //     </>
// //   );
// // };

// // export default NavBar;

// import React, { useState, useEffect, useRef } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { FiUser, FiShoppingBag, FiSearch, FiMenu, FiX } from "react-icons/fi";

// // Helper hook for small screen detection
// function useIsSmallScreen(breakpoint = 768) {
//   const [isSmall, setIsSmall] = useState(
//     typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
//   );
//   useEffect(() => {
//     const handler = () => setIsSmall(window.innerWidth <= breakpoint);
//     window.addEventListener("resize", handler);
//     return () => window.removeEventListener("resize", handler);
//   }, [breakpoint]);
//   return isSmall;
// }

// const NavBar = ({ navigate, cartCount, wishlistCount, user }) => {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [searchOpen, setSearchOpen] = useState(false);
//   const [isAtTop, setIsAtTop] = useState(true);
//   const [isNavVisible, setIsNavVisible] = useState(true);

//   const isSmallScreen = useIsSmallScreen();

//   // For tracking last scroll position for hide on scroll effect
//   const lastScrollY = useRef(
//     typeof window !== "undefined" ? window.scrollY : 0
//   );

//   useEffect(() => {
//     document.body.style.overflow = mobileOpen ? "hidden" : "";
//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, [mobileOpen]);

//   useEffect(() => {
//     const handleScroll = () => {
//       setIsAtTop(window.scrollY <= 0);

//       if (isSmallScreen) {
//         // Hide navbar if scrolling down, show if scrolling up or at top
//         const currentScrollY = window.scrollY;
//         if (currentScrollY <= 0) {
//           setIsNavVisible(true);
//         } else {
//           if (currentScrollY > lastScrollY.current + 5) {
//             setIsNavVisible(false);
//           } else if (currentScrollY < lastScrollY.current - 5) {
//             setIsNavVisible(true);
//           }
//         }
//         lastScrollY.current = currentScrollY;
//       } else {
//         // Always show nav on desktop
//         setIsNavVisible(true);
//       }
//     };

//     window.addEventListener("scroll", handleScroll, { passive: true });
//     handleScroll();
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, [isSmallScreen]);

//   const links = [
//     { label: "HOME", page: "home" },
//     { label: "SHOP ALL", page: "products" },
//     { label: "ABOUT US", page: "home" },
//     { label: "CONTACT", page: "home" },
//   ];

//   const IconBtn = ({ onClick, label, badge, children }) => (
//     <button
//       onClick={onClick}
//       aria-label={label}
//       style={{
//         position: "relative",
//         background: "none",
//         border: "none",
//         cursor: "pointer",
//         color: "#fff",
//         padding: "6px 8px",
//         display: "flex",
//         alignItems: "center",
//       }}
//     >
//       {children}
//       {badge > 0 && (
//         <span
//           style={{
//             position: "absolute",
//             top: 2,
//             right: 2,
//             background: "#fff",
//             color: "#000",
//             borderRadius: "50%",
//             width: 15,
//             height: 15,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             fontSize: 8,
//             fontWeight: 700,
//           }}
//         >
//           {badge}
//         </span>
//       )}
//     </button>
//   );

//   // AnimatePresence can animate nav itself for smooth hide/show on scroll (small screen)
//   return (
//     <>
//       {/* ── ANNOUNCEMENT BAR ── */}
//       <div
//         style={{
//           background: "#fff",
//           color: "#000",
//           textAlign: "center",
//           padding: "8px 16px",
//           fontSize: "clamp(11px,1.3vw,13px)",
//           fontFamily: "'Barlow Condensed', 'DM Sans', sans-serif",
//           fontWeight: 600,
//           letterSpacing: "0.06em",
//           position: "fixed",
//           top: 0,
//           left: 0,
//           right: 0,
//           zIndex: 101,
//         }}
//       >
//         GET 10% OFF ON PREPAID ORDERS
//       </div>

//       <AnimatePresence>
//         {(isNavVisible || !isSmallScreen) && (
//           <motion.nav
//             key="main-nav"
//             initial={isSmallScreen ? { y: 0, opacity: 1 } : false}
//             animate={isSmallScreen ? { y: 0, opacity: 1 } : false}
//             exit={isSmallScreen ? { y: -80, opacity: 0 } : false}
//             transition={{ type: "tween", duration: 0.24 }}
//             style={{
//               position: "fixed",
//               top: 32,
//               left: 0,
//               right: 0,
//               zIndex: 100,
//               width: "100%",
//               display: "flex",
//               justifyContent: "center",
//               padding: isAtTop ? 0 : "10px 0",
//               transition: "padding 0.3s ease",
//               // prevent pointer events when hidden so user can't interact accidentally
//               pointerEvents: isNavVisible ? undefined : "none",
//             }}
//             aria-label="Main navigation"
//           >
//             <div
//               style={{
//                 width: isAtTop ? "100%" : "96%",
//                 maxWidth: isAtTop ? "none" : 1400,
//                 height: 56,
//                 borderRadius: isAtTop ? 0 : 999,
//                 background: isAtTop ? "#000" : "rgba(126, 126, 126, 0.6)",
//                 backdropFilter: isAtTop ? "none" : "blur(8px)",
//                 WebkitBackdropFilter: isAtTop ? "none" : "blur(14px)",
//                 border: isAtTop
//                   ? "none"
//                   : "1px solid rgba(255,255,255,0.08)",
//                 borderBottom:
//                   isAtTop
//                     ? "1px solid rgba(255,255,255,0.08)"
//                     : "1px solid rgba(255,255,255,0.08)",
//                 boxShadow: isAtTop
//                   ? "none"
//                   : "0 8px 30px rgba(0,0,0,0.45), 0 1.5px 5px rgba(0,0,0,0.25)",
//                 transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)",
//                 display: "flex",
//                 alignItems: "center",
//                 position: "relative"
//               }}
//             >
//               <div
//                 style={{
//                   width: "100%",
//                   height: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   padding: "0 clamp(16px,3vw,32px)",
//                   position: "relative",
//                 }}
//               >
//                 {/* LEFT: Nav Links & Hamburger & Brand Logo (mobile) */}
//                 <div
//                   style={{
//                     flex: 1,
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 8,
//                     minWidth: 0,
//                   }}
//                 >
//                   {/* Hamburger — mobile only */}
//                   <button
//                     onClick={() => setMobileOpen(true)}
//                     aria-label="Open menu"
//                     className="ll-hamburger"
//                     style={{
//                       display: "none",
//                       background: "none",
//                       border: "none",
//                       cursor: "pointer",
//                       color: "#fff",
//                       padding: 6,
//                     }}
//                   >
//                     <FiMenu size={22} />
//                   </button>

//                   {/* Left-aligned Brand Logo (mobile only) */}
//                   <span
//                     className="ll-mobile-logo"
//                     onClick={() => navigate("home")}
//                     style={{
//                       display: "none",
//                       fontFamily: "'Playfair Display', 'Cormorant Garamond', 'Barlow Condensed', 'Impact', serif",
//                       fontWeight: 900,
//                       fontSize: "18px",
//                       color: "#fff",
//                       letterSpacing: "0.11em",
//                       cursor: "pointer",
//                       userSelect: "none",
//                       lineHeight: 1.08,
//                       textShadow: "0 2px 10px rgba(0,0,0,0.26)",
//                       textTransform: "uppercase",
//                       pointerEvents: "auto",
//                       marginLeft: 8,
//                     }}
//                   >
//                     UNLEASH CLUB
//                   </span>

//                   {/* Desktop Nav Links */}
//                   <div
//                     className="ll-desktop-links"
//                     style={{
//                       display: "flex",
//                       gap: "clamp(16px,2.5vw,36px)",
//                       alignItems: "center",
//                     }}
//                   >
//                     {links.map((l) => (
//                       <button
//                         key={l.label}
//                         onClick={() => navigate(l.page)}
//                         style={{
//                           background: "none",
//                           border: "none",
//                           cursor: "pointer",
//                           color: "#fff",
//                           fontFamily:
//                             "'Barlow Condensed', 'DM Sans', sans-serif",
//                           fontSize: "clamp(12px,1.1vw,14px)",
//                           fontWeight: 600,
//                           letterSpacing: "0.1em",
//                           padding: 0,
//                           transition: "color 0.2s",
//                         }}
//                         onMouseEnter={(e) =>
//                           (e.target.style.color = "#bbb")
//                         }
//                         onMouseLeave={(e) =>
//                           (e.target.style.color = "#fff")
//                         }
//                       >
//                         {l.label}
//                       </button>
//                     ))}
//                   </div>
//                 </div>

//                 {/* CENTER: Brand Logo (desktop only) */}
//                 <div
//                   style={{
//                     flex: "0 1 auto",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     width: "100%",
//                     position: "absolute",
//                     left: 0,
//                     right: 0,
//                     pointerEvents: "none",
//                     zIndex: 2,
//                     height: "100%",
//                   }}
//                 >
//                   <span
//                     className="ll-desktop-logo"
//                     onClick={() => navigate("home")}
//                     style={{
//                       fontFamily:
//                         "'Playfair Display', 'Cormorant Garamond', 'Barlow Condensed', 'Impact', serif",
//                       fontWeight: 900,
//                       fontSize: "clamp(18px,2.0vw,26px)",
//                       color: "#fff",
//                       letterSpacing: "0.11em",
//                       cursor: "pointer",
//                       userSelect: "none",
//                       lineHeight: 1.08,
//                       textShadow: "0 2px 10px rgba(0,0,0,0.26)",
//                       textTransform: "uppercase",
//                       pointerEvents: "auto",
//                     }}
//                   >
//                     UNLEASH CLUB
//                   </span>
//                 </div>

//                 {/* RIGHT: Icons */}
//                 <div
//                   style={{
//                     flex: 1,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "flex-end",
//                     gap: 0,
//                   }}
//                 >
//                   <IconBtn
//                     onClick={() => setSearchOpen((v) => !v)}
//                     label="Search"
//                   >
//                     <FiSearch size={18} />
//                   </IconBtn>
//                   <IconBtn
//                     onClick={() => navigate(user ? "profile" : "auth")}
//                     label="Account"
//                   >
//                     <FiUser size={18} />
//                   </IconBtn>
//                   <IconBtn
//                     onClick={() => navigate("cart")}
//                     label="Cart"
//                     badge={cartCount}
//                   >
//                     <FiShoppingBag size={18} />
//                   </IconBtn>
//                 </div>
//               </div>

//               {/* Search Bar dropdown */}
//               <AnimatePresence>
//                 {searchOpen && (
//                   <motion.div
//                     initial={{ opacity: 0, y: -8 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     exit={{ opacity: 0, y: -8 }}
//                     style={{
//                       position: "absolute",
//                       top: "100%",
//                       left: 0,
//                       right: 0,
//                       marginTop: isAtTop ? 0 : 10,
//                       background: "rgba(17,17,17,0.85)",
//                       backdropFilter: "blur(14px)",
//                       WebkitBackdropFilter: "blur(14px)",
//                       borderRadius: isAtTop ? 0 : 16,
//                       border: "1px solid rgba(255,255,255,0.1)",
//                       padding: "12px clamp(16px,3vw,32px)",
//                     }}
//                   >
//                     <div
//                       style={{
//                         maxWidth: 600,
//                         margin: "0 auto",
//                         display: "flex",
//                         gap: 0,
//                       }}
//                     >
//                       <input
//                         autoFocus
//                         placeholder="Search products..."
//                         style={{
//                           flex: 1,
//                           background: "rgba(255,255,255,0.07)",
//                           border: "1px solid rgba(255,255,255,0.15)",
//                           borderRight: "none",
//                           color: "#fff",
//                           padding: "10px 14px",
//                           fontSize: 14,
//                           fontFamily: "'DM Sans', sans-serif",
//                           borderRadius: "2px 0 0 2px",
//                           outline: "none",
//                         }}
//                       />
//                       <button
//                         style={{
//                           background: "#fff",
//                           border: "none",
//                           color: "#000",
//                           padding: "10px 18px",
//                           cursor: "pointer",
//                           borderRadius: "0 2px 2px 0",
//                           fontFamily: "'Barlow Condensed', sans-serif",
//                           fontWeight: 700,
//                           letterSpacing: "0.1em",
//                           fontSize: 13,
//                         }}
//                       >
//                         SEARCH
//                       </button>
//                     </div>
//                   </motion.div>
//                 )}
//               </AnimatePresence>
//             </div>
//           </motion.nav>
//         )}
//       </AnimatePresence>

//       {/* ── MOBILE DRAWER ── */}
//       <AnimatePresence>
//         {mobileOpen && (
//           <>
//             <motion.div
//               key="backdrop"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 0.6 }}
//               exit={{ opacity: 0 }}
//               onClick={() => setMobileOpen(false)}
//               style={{
//                 position: "fixed",
//                 inset: 0,
//                 background: "#000",
//                 zIndex: 200,
//               }}
//             />
//             <motion.div
//               key="drawer"
//               initial={{ x: "-100%" }}
//               animate={{ x: 0 }}
//               exit={{ x: "-100%" }}
//               transition={{ type: "spring", stiffness: 280, damping: 28 }}
//               style={{
//                 position: "fixed",
//                 top: 0,
//                 left: 0,
//                 bottom: 0,
//                 width: "min(300px, 85vw)",
//                 background: "rgba(10,10,10,0.85)",
//                 backdropFilter: "blur(16px)",
//                 WebkitBackdropFilter: "blur(16px)",
//                 zIndex: 201,
//                 display: "flex",
//                 flexDirection: "column",
//                 padding: "24px 28px",
//                 borderRight: "1px solid rgba(255,255,255,0.08)",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   marginBottom: 36,
//                 }}
//               >
//                 <span
//                   style={{
//                     fontFamily: "'Barlow Condensed', 'Impact', sans-serif",
//                     fontWeight: 800,
//                     fontSize: 20,
//                     color: "#fff",
//                     letterSpacing: "0.08em",
//                   }}
//                 >
//                   UNLEASH CLUB
//                 </span>
//                 <button
//                   onClick={() => setMobileOpen(false)}
//                   style={{
//                     background: "none",
//                     border: "none",
//                     cursor: "pointer",
//                     color: "#fff",
//                     padding: 4,
//                   }}
//                 >
//                   <FiX size={22} />
//                 </button>
//               </div>

//               <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
//                 {links.map((l) => (
//                   <button
//                     key={l.label}
//                     onClick={() => {
//                       setMobileOpen(false);
//                       navigate(l.page);
//                     }}
//                     style={{
//                       background: "none",
//                       border: "none",
//                       cursor: "pointer",
//                       color: "#fff",
//                       fontFamily:
//                         "'Barlow Condensed', 'DM Sans', sans-serif",
//                       fontSize: 20,
//                       fontWeight: 600,
//                       letterSpacing: "0.1em",
//                       textAlign: "left",
//                       padding: "14px 0",
//                       borderBottom: "1px solid rgba(255,255,255,0.07)",
//                       transition: "color 0.2s",
//                     }}
//                     onMouseEnter={(e) =>
//                       (e.currentTarget.style.color = "#bbb")
//                     }
//                     onMouseLeave={(e) =>
//                       (e.currentTarget.style.color = "#fff")
//                     }
//                   >
//                     {l.label}
//                   </button>
//                 ))}
//               </div>

//               <div
//                 style={{
//                   marginTop: "auto",
//                   paddingTop: 24,
//                   borderTop: "1px solid rgba(255,255,255,0.08)",
//                   display: "flex",
//                   gap: 12,
//                 }}
//               >
//                 <IconBtn
//                   onClick={() => {
//                     setMobileOpen(false);
//                     navigate("cart");
//                   }}
//                   label="Cart"
//                   badge={cartCount}
//                 >
//                   <FiShoppingBag size={22} />
//                 </IconBtn>
//                 <IconBtn
//                   onClick={() => {
//                     setMobileOpen(false);
//                     navigate(user ? "profile" : "auth");
//                   }}
//                   label="Account"
//                 >
//                   <FiUser size={22} />
//                 </IconBtn>
//               </div>
//             </motion.div>
//           </>
//         )}
//       </AnimatePresence>

//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800&display=swap');
//         @media (max-width: 768px) {
//           .ll-hamburger { display: flex !important; }
//           .ll-desktop-links { display: none !important; }
//           .ll-desktop-logo { display: none !important; }
//           .ll-mobile-logo { display: flex !important; align-items: center; margin-left: 8px; }
//         }
//         @media (min-width: 769px) {
//           .ll-hamburger { display: none !important; }
//           .ll-desktop-logo { display: flex !important; }
//           .ll-mobile-logo { display: none !important; }
//         }
//       `}</style>
//     </>
//   );
// };

// export default NavBar;

import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiUser, FiShoppingBag, FiSearch, FiMenu, FiX } from "react-icons/fi";
 
// Helper hook for small screen detection
function useIsSmallScreen(breakpoint = 768) {
  const [isSmall, setIsSmall] = useState(
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
  );
  useEffect(() => {
    const handler = () => setIsSmall(window.innerWidth <= breakpoint);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, [breakpoint]);
  return isSmall;
}
 
const NavBar = ({ navigate, cartCount, wishlistCount, user }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [isAtTop, setIsAtTop] = useState(true);
  const [isNavVisible, setIsNavVisible] = useState(true);
 
  const isSmallScreen = useIsSmallScreen();
 
  // For tracking last scroll position for hide on scroll effect
  const lastScrollY = useRef(
    typeof window !== "undefined" ? window.scrollY : 0
  );
 
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);
 
  useEffect(() => {
    const handleScroll = () => {
      setIsAtTop(window.scrollY <= 0);
 
      if (isSmallScreen) {
        // Hide navbar if scrolling down, show if scrolling up or at top
        const currentScrollY = window.scrollY;
        if (currentScrollY <= 0) {
          setIsNavVisible(true);
        } else {
          if (currentScrollY > lastScrollY.current + 5) {
            setIsNavVisible(false);
          } else if (currentScrollY < lastScrollY.current - 5) {
            setIsNavVisible(true);
          }
        }
        lastScrollY.current = currentScrollY;
      } else {
        // Always show nav on desktop
        setIsNavVisible(true);
      }
    };
 
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isSmallScreen]);
 
  const links = [
    { label: "HOME", page: "home" },
    { label: "SHOP ALL", page: "products" },
    { label: "ABOUT US", page: "about" },
    { label: "CONTACT", page: "contact" },
  ];
 
  const IconBtn = ({ onClick, label, badge, children }) => (
    <button
      onClick={onClick}
      aria-label={label}
      style={{
        position: "relative",
        background: "none",
        border: "none",
        cursor: "pointer",
        color: "#fff",
        padding: "6px 8px",
        display: "flex",
        alignItems: "center",
      }}
    >
      {children}
      {badge > 0 && (
        <span
          style={{
            position: "absolute",
            top: 2,
            right: 2,
            background: "#fff",
            color: "#000",
            borderRadius: "50%",
            width: 15,
            height: 15,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 8,
            fontWeight: 700,
          }}
        >
          {badge}
        </span>
      )}
    </button>
  );
 
  // AnimatePresence can animate nav itself for smooth hide/show on scroll (small screen)
  return (
    <>
      {/* ── ANNOUNCEMENT BAR ── */}
      <div
        style={{
          background: "#fff",
          color: "#000",
          textAlign: "center",
          padding: "8px 16px",
          fontSize: "clamp(11px,1.3vw,13px)",
          fontFamily: "'Barlow Condensed', 'DM Sans', sans-serif",
          fontWeight: 600,
          letterSpacing: "0.06em",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 101,
        }}
      >
        GET 10% OFF ON PREPAID ORDERS
      </div>
 
      <AnimatePresence>
        {(isNavVisible || !isSmallScreen) && (
          <motion.nav
            key="main-nav"
            initial={isSmallScreen ? { y: 0, opacity: 1 } : false}
            animate={isSmallScreen ? { y: 0, opacity: 1 } : false}
            exit={isSmallScreen ? { y: -80, opacity: 0 } : false}
            transition={{ type: "tween", duration: 0.24 }}
            style={{
              position: "fixed",
              top: 32,
              left: 0,
              right: 0,
              zIndex: 100,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              padding: isAtTop ? 0 : "10px 0",
              transition: "padding 0.3s ease",
              // prevent pointer events when hidden so user can't interact accidentally
              pointerEvents: isNavVisible ? undefined : "none",
            }}
            aria-label="Main navigation"
          >
            <div
              style={{
                width: isAtTop ? "100%" : "96%",
                maxWidth: isAtTop ? "none" : 1400,
                height: 56,
                borderRadius: isAtTop ? 0 : 999,
                background: isAtTop ? "#000" : "rgba(126, 126, 126, 0.6)",
                backdropFilter: isAtTop ? "none" : "blur(8px)",
                WebkitBackdropFilter: isAtTop ? "none" : "blur(14px)",
                border: isAtTop
                  ? "none"
                  : "1px solid rgba(255,255,255,0.08)",
                borderBottom:
                  isAtTop
                    ? "1px solid rgba(255,255,255,0.08)"
                    : "1px solid rgba(255,255,255,0.08)",
                boxShadow: isAtTop
                  ? "none"
                  : "0 8px 30px rgba(0,0,0,0.45), 0 1.5px 5px rgba(0,0,0,0.25)",
                transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)",
                display: "flex",
                alignItems: "center",
                position: "relative"
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "0 clamp(16px,3vw,32px)",
                  position: "relative",
                }}
              >
                {/* LEFT: Nav Links & Hamburger & Brand Logo (mobile) */}
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: 0,
                  }}
                >
                  {/* Hamburger — mobile only */}
                  <button
                    onClick={() => setMobileOpen(true)}
                    aria-label="Open menu"
                    className="ll-hamburger"
                    style={{
                      display: "none",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#fff",
                      padding: 6,
                    }}
                  >
                    <FiMenu size={22} />
                  </button>
 
                  {/* Left-aligned Brand Logo (mobile only) */}
                  <span
                    className="ll-mobile-logo"
                    onClick={() => navigate("home")}
                    style={{
                      display: "none",
                      fontFamily: "'Playfair Display', 'Cormorant Garamond', 'Barlow Condensed', 'Impact', serif",
                      fontWeight: 900,
                      fontSize: "18px",
                      color: "#fff",
                      letterSpacing: "0.11em",
                      cursor: "pointer",
                      userSelect: "none",
                      lineHeight: 1.08,
                      textShadow: "0 2px 10px rgba(0,0,0,0.26)",
                      textTransform: "uppercase",
                      pointerEvents: "auto",
                      marginLeft: 8,
                    }}
                  >
                    UNLEASH CLUB
                  </span>
 
                  {/* Desktop Nav Links */}
                  <div
                    className="ll-desktop-links"
                    style={{
                      display: "flex",
                      gap: "clamp(16px,2.5vw,36px)",
                      alignItems: "center",
                    }}
                  >
                    {links.map((l) => (
                      <button
                        key={l.label}
                        onClick={() => navigate(l.page)}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          color: "#fff",
                          fontFamily:
                            "'Barlow Condensed', 'DM Sans', sans-serif",
                          fontSize: "clamp(12px,1.1vw,14px)",
                          fontWeight: 600,
                          letterSpacing: "0.1em",
                          padding: 0,
                          transition: "color 0.2s",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.color = "#bbb")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.color = "#fff")
                        }
                      >
                        {l.label}
                      </button>
                    ))}
                  </div>
                </div>
 
                {/* CENTER: Brand Logo (desktop only) */}
                <div
                  style={{
                    flex: "0 1 auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    position: "absolute",
                    left: 0,
                    right: 0,
                    pointerEvents: "none",
                    zIndex: 2,
                    height: "100%",
                  }}
                >
                  <span
                    className="ll-desktop-logo"
                    onClick={() => navigate("home")}
                    style={{
                      fontFamily:
                        "'Playfair Display', 'Cormorant Garamond', 'Barlow Condensed', 'Impact', serif",
                      fontWeight: 900,
                      fontSize: "clamp(18px,2.0vw,26px)",
                      color: "#fff",
                      letterSpacing: "0.11em",
                      cursor: "pointer",
                      userSelect: "none",
                      lineHeight: 1.08,
                      textShadow: "0 2px 10px rgba(0,0,0,0.26)",
                      textTransform: "uppercase",
                      pointerEvents: "auto",
                    }}
                  >
                    UNLEASH CLUB
                  </span>
                </div>
 
                {/* RIGHT: Icons */}
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: 0,
                  }}
                >
                  <IconBtn
                    onClick={() => setSearchOpen((v) => !v)}
                    label="Search"
                  >
                    <FiSearch size={18} />
                  </IconBtn>
                  <IconBtn
                    onClick={() => navigate(user ? "profile" : "auth")}
                    label="Account"
                  >
                    <FiUser size={18} />
                  </IconBtn>
                  <IconBtn
                    onClick={() => navigate("cart")}
                    label="Cart"
                    badge={cartCount}
                  >
                    <FiShoppingBag size={18} />
                  </IconBtn>
                </div>
              </div>
 
              {/* Search Bar dropdown */}
              <AnimatePresence>
                {searchOpen && (
                  <motion.div
                    initial={{ opacity: 0, y: -8 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -8 }}
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      marginTop: isAtTop ? 0 : 10,
                      background: "rgba(17,17,17,0.85)",
                      backdropFilter: "blur(14px)",
                      WebkitBackdropFilter: "blur(14px)",
                      borderRadius: isAtTop ? 0 : 16,
                      border: "1px solid rgba(255,255,255,0.1)",
                      padding: "12px clamp(16px,3vw,32px)",
                    }}
                  >
                    <div
                      style={{
                        maxWidth: 600,
                        margin: "0 auto",
                        display: "flex",
                        gap: 0,
                      }}
                    >
                      <input
                        autoFocus
                        placeholder="Search products..."
                        style={{
                          flex: 1,
                          background: "rgba(255,255,255,0.07)",
                          border: "1px solid rgba(255,255,255,0.15)",
                          borderRight: "none",
                          color: "#fff",
                          padding: "10px 14px",
                          fontSize: 14,
                          fontFamily: "'DM Sans', sans-serif",
                          borderRadius: "2px 0 0 2px",
                          outline: "none",
                        }}
                      />
                      <button
                        style={{
                          background: "#fff",
                          border: "none",
                          color: "#000",
                          padding: "10px 18px",
                          cursor: "pointer",
                          borderRadius: "0 2px 2px 0",
                          fontFamily: "'Barlow Condensed', sans-serif",
                          fontWeight: 700,
                          letterSpacing: "0.1em",
                          fontSize: 13,
                        }}
                      >
                        SEARCH
                      </button>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
 
      {/* ── MOBILE DRAWER ── */}
      <AnimatePresence>
        {mobileOpen && (
          <>
            <motion.div
              key="backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.6 }}
              exit={{ opacity: 0 }}
              onClick={() => setMobileOpen(false)}
              style={{
                position: "fixed",
                inset: 0,
                background: "#000",
                zIndex: 200,
              }}
            />
            <motion.div
              key="drawer"
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ type: "spring", stiffness: 280, damping: 28 }}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                bottom: 0,
                width: "min(300px, 85vw)",
                background: "rgba(10,10,10,0.85)",
                backdropFilter: "blur(16px)",
                WebkitBackdropFilter: "blur(16px)",
                zIndex: 201,
                display: "flex",
                flexDirection: "column",
                padding: "24px 28px",
                borderRight: "1px solid rgba(255,255,255,0.08)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 36,
                }}
              >
                <span
                  style={{
                    fontFamily: "'Barlow Condensed', 'Impact', sans-serif",
                    fontWeight: 800,
                    fontSize: 20,
                    color: "#fff",
                    letterSpacing: "0.08em",
                  }}
                >
                  UNLEASH CLUB
                </span>
                <button
                  onClick={() => setMobileOpen(false)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#fff",
                    padding: 4,
                  }}
                >
                  <FiX size={22} />
                </button>
              </div>
 
              <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
                {links.map((l) => (
                  <button
                    key={l.label}
                    onClick={() => {
                      setMobileOpen(false);
                      navigate(l.page);
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#fff",
                      fontFamily:
                        "'Barlow Condensed', 'DM Sans', sans-serif",
                      fontSize: 20,
                      fontWeight: 600,
                      letterSpacing: "0.1em",
                      textAlign: "left",
                      padding: "14px 0",
                      borderBottom: "1px solid rgba(255,255,255,0.07)",
                      transition: "color 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.color = "#bbb")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.color = "#fff")
                    }
                  >
                    {l.label}
                  </button>
                ))}
              </div>
 
              <div
                style={{
                  marginTop: "auto",
                  paddingTop: 24,
                  borderTop: "1px solid rgba(255,255,255,0.08)",
                  display: "flex",
                  gap: 12,
                }}
              >
                <IconBtn
                  onClick={() => {
                    setMobileOpen(false);
                    navigate("cart");
                  }}
                  label="Cart"
                  badge={cartCount}
                >
                  <FiShoppingBag size={22} />
                </IconBtn>
                <IconBtn
                  onClick={() => {
                    setMobileOpen(false);
                    navigate(user ? "profile" : "auth");
                  }}
                  label="Account"
                >
                  <FiUser size={22} />
                </IconBtn>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
 
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800&display=swap');
        @media (max-width: 768px) {
          .ll-hamburger { display: flex !important; }
          .ll-desktop-links { display: none !important; }
          .ll-desktop-logo { display: none !important; }
          .ll-mobile-logo { display: flex !important; align-items: center; margin-left: 8px; }
        }
        @media (min-width: 769px) {
          .ll-hamburger { display: none !important; }
          .ll-desktop-logo { display: flex !important; }
          .ll-mobile-logo { display: none !important; }
        }
      `}</style>
    </>
  );
};
 
export default NavBar;


